import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';

import { LoggerService } from '@services/logger.service';
import { environment } from '../../../../environments/environment';

// This config object is built outside Angular's injection context, so a plain
// instance is used rather than inject(LoggerService).
const logger = new LoggerService();

export const socialAuthConfig: SocialAuthServiceConfig = {
  autoLogin: false,
  lang: 'en',
  providers: [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(environment.social_login.google.client_id), // Replace with your actual client ID
    },
    // {
    //   id: FacebookLoginProvider.PROVIDER_ID,
    //   provider: new FacebookLoginProvider('YOUR_FACEBOOK_APP_ID') // Replace with your actual client ID
    // }
  ],
  onError: error => {
    logger.error('Social login error:', error);
  },
};
